import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {HelpModal} from 'shells/modal/help-modal';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {UtmParametersHelpGraphic} from '../../email-marketing/editions/editions-details/utm-modals/assets/utm-parameters-help-graphic';

import styles from './tooltip-modal-styles.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function FormEngagementMetricModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            artImage={<UtmParametersHelpGraphic />}
            bodyComponent={
                <div className={styles.container}>
                    <ModalHeader>Form engagement</ModalHeader>
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            Nutshell automatically tracks three metrics for form performance. This
                            data is calculated using information from all of the webpages where this
                            form has been embedded.
                        </ModalBody>
                    </SpacerGroup>
                    <BulletedList
                        bullets={[
                            <ModalBody key='1'>
                                <b>Page visits</b> show the total number of page visits to every
                                webpage where this form is embedded
                            </ModalBody>,
                            <ModalBody key='2'>
                                <b>Form submissions</b> represent the total number of submissions
                                for this form
                            </ModalBody>,
                            <ModalBody key='3'>
                                <b>Conversion rate</b> is the percentage of page visits that result
                                in form submissions
                            </ModalBody>,
                        ]}
                    />
                </div>
            }
        />
    );
}
